import { Component, Inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import type { Button } from '../error/error.dialog';

@Component({
    selector: 'dl-error-large-dialog',
    imports: [MatIconModule, MatButtonModule],
    template: `
    <div class="w-[360px] p-6 flex flex-col !items-center !justify-center">
      <mat-icon
        class="!w-[88px] !h-[88px] bg-red-500 rounded-full !text-6xl !leading-[88px] text-center text-white"
        >close</mat-icon
      >
      <div class="title mt-4 text-2xl text-center">{{ title() }}</div>
      <div class="content mt-3 text-center">{{ content() }}</div>
      <div class="buttons mt-6">
        @for (button of buttons(); track button.label) {
          @switch (button.type) {
            @case ('raised') {
              <button
                mat-raised-button
                (click)="close(button.result)"
                [color]="button.color"
                [attr.data-testid]="'error-dialog-raised-button'"
              >
                {{ button.label }}
              </button>
            }
            @default {
              <button
                mat-button
                (click)="close(button.result)"
                [color]="button.color"
                [attr.data-testid]="'error-dialog-button'"
              >
                {{ button.label }}
              </button>
            }
          }
        }
      </div>
    </div>
  `
})
export class ErrorLargeDialog {
  public title = signal<string>('');
  public content = signal<string>('');
  public buttons = signal<Button[]>([]);

  public constructor(
    private readonly _matDialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA)
    public data?: {
      title: string;
      content: string;
      buttons: Button[];
    },
  ) {
    if (this.data) {
      this.title.set(this.data.title);
      this.content.set(this.data.content);
      this.buttons.set(this.data.buttons);
    }
  }

  public close(result: string) {
    this._matDialogRef.close(result);
  }
}
